module.exports = __webpack_public_path__ + "img/flags@2x.f2c77a6b.png";